<template>
  <div
    class="viewcontent"
    v-if="translations.errors && translations.event && translations.buttons"
  >
    <form class="row mx-3">
      <h1>{{ defineTitle(event.title) }}</h1>

      <div class="col-sm-6 col-xs-12">
        <label for="language" class="form-label w-100 my-3"
          >{{ translations.event.form_languages }}
          <span class="text-danger">*</span>
          <SelectMultiple
            v-model="input.languages"
            :title="''"
            :values="languages"
            name="languages"
            class="selector"
            :filter="true"
            :max="1"
            required
            disabled
          />
        </label>
        <div v-if="input.languages">
          <div v-for="(item, index) in input.languages" :key="index">
            <label
              for="full_name"
              class="form-label w-100 my-3"
              v-for="(title, titleindex) in checkTitleLanguage(item)"
              :key="titleindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.event.form_title }}

              <input
                type="text"
                id="full_name"
                name="full_name"
                class="form-control"
                v-model="title.text"
                disabled
              />
            </label>

            <label
              for="description"
              class="form-label w-100 my-3"
              v-for="(description,
              descriptionindex) in checkDescriptionLanguage(item)"
              :key="descriptionindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.event.form_description }}

              <textarea
                rows="5"
                class="form-control"
                id="description"
                name="description"
                v-model="description.text"
                disabled
              >
              </textarea>
            </label>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-xs-12">
        <div class="col-12 p-4" v-if="Array.isArray(event.pictures)">
          <div class="col-12">
            <img
              v-for="(item, index) in event.pictures"
              :key="index"
              class="img-fluid img-thumbnail"
              :src="files + item"
              :alt="event.title"
            />
          </div>
        </div>
        <label for="date_start" class="form-label w-50 my-3"
          >{{ translations.event.form_date_start }}
          <input
            class="form-control"
            type="date"
            id="date_start"
            v-model="event.date_start"
            disabled
          /> </label
        ><label for="date_end" class="form-label w-50 my-3"
          >{{ translations.event.form_date_end }}
          <input
            class="form-control"
            type="date"
            id="date_end"
            v-model="event.date_end"
            disabled
          />
        </label>
        <label for="eventurl" class="form-label w-100 my-3"
          >{{ translations.event.form_url }}
          <input
            class="form-control"
            type="text"
            id="eventurl"
            v-model="event.url"
            disabled
          />
        </label>
      </div>
      <div class="col-12 pt-2">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import SelectMultiple from '@/components/SelectMultiple.vue'
  import Activities from '@/components/Activities.vue'
  export default {
    name: 'ToolEventRead',
    components: {
      SelectMultiple,
      Activities,
    },
    data() {
      return {
        input: {
          languages: [],
          title: [],
          description: [],
        },
        preview: false,
      }
    },
    computed: {
      ...mapState([
        'languages',
        'event',
        'files',
        'languageSelected',
        'translations',
      ]),
    },
    methods: {
      ...mapActions(['resetError', 'changeToolSelected']),
      generateInputs() {
        if (
          this.input.languages &&
          this.input.languages.length > 0 &&
          this.input.title
        ) {
          for (let index = 0; index < this.input.languages.length; index++) {
            let found = this.input.title.some(
              (el) => el.key === this.input.languages[index]
            )
            if (!found) {
              this.input.title.push({
                key: this.input.languages[index],
                text: '',
              })
              this.input.description.push({
                key: this.input.languages[index],
                text: '',
              })
            }
          }
        } else {
          this.input.title = []
          this.input.description = []
        }
      },
      cancel() {
        this.changeToolSelected(null)
      },
      checkTitleLanguage(language) {
        return this.input.title.filter((item) => item.key == language)
      },
      checkDescriptionLanguage(language) {
        return this.input.description.filter((item) => item.key == language)
      },
      async setInputs() {
        if (this.event.languages && this.input.languages.length <= 0) {
          this.input = {
            languages: Object.values(this.event.languages),
            title: this.event.title,
            description: this.event.description,
          }
          if (this.input.title && this.input.title.length <= 0) {
            await this.generateInputs()
          }
        }
      },
      defineTitle(title) {
        let text = ''

        if (title && title.length > 0) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
    },
    async created() {
      await this.setInputs()
    },

    beforeUnmount() {
      this.resetError()
    },
  }
</script>

<style scoped>
  .key {
    text-transform: uppercase;
    font-weight: bold;
  }
  img {
    max-height: 200px;
  }
</style>
